module.exports = __webpack_public_path__ + "img/badge_rimborso_aff_mutui.e1ebc002.jpg";